"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJSON = getJSON;
exports.fetchJSON = fetchJSON;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

// import { HTTPError, TimeoutError } from './errors';
// abort-error
// type ErrorTypeEnum = 'http-error' | 'invalid-json';
//
// What user can be notified about?
//
// http:
// - not-found (404)
// - server-error (500, generic message)
// - invalid (400, invalid form)
// - unauthorized (401 invalid login)
// - forbidden (403 not allowed e.g. permissions, not logged in)
// also:
// - timeout => retry?
// - network => retry?
//
// Constraints:
// - only GET POST PUT PATCH DELETE makes sense working w/ JSON
// - GET is not allowed to have data (body)
//
// Use low-level API if not suited.
//
// error: request was made, but something went wrong withing the response
// failure: failure to make request (it couldn't be completed)
function doJSONFetch(_x) {
  return _doJSONFetch.apply(this, arguments);
}

function _doJSONFetch() {
  _doJSONFetch = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(opts) {
    var env, url, method, inputData, response, errorName, data, message;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            env = opts.env, url = opts.url, method = opts.method, inputData = opts.data;

            if (url) {
              _context.next = 4;
              break;
            }

            if (process.env.NODE_ENV !== 'production') {
              console.warn('No url passed.');
            }

            return _context.abrupt("return", {
              status: 'failure',
              errorType: 'unknown',
              response: response
            });

          case 4:
            _context.prev = 4;
            _context.next = 7;
            return env.ky(url, {
              method: method,
              json: inputData
            });

          case 7:
            response = _context.sent;
            _context.next = 17;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            // pass error
            env.onError(_context.t0); // handle errors

            errorName = _context.t0.name;

            if (!(errorName === 'TimeoutError')) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", {
              status: 'failure',
              errorType: 'timeout',
              response: response
            });

          case 16:
            return _context.abrupt("return", {
              status: 'failure',
              errorType: 'unknown',
              response: response
            });

          case 17:
            if (response.ok) {
              _context.next = 20;
              break;
            }

            if (!(response.status >= 500)) {
              _context.next = 20;
              break;
            }

            return _context.abrupt("return", {
              response: response,
              data: null,
              status: 'error',
              errorType: 'http-error',
              httpError: 'server-error'
            });

          case 20:
            _context.prev = 20;
            _context.next = 23;
            return response.json();

          case 23:
            data = _context.sent;
            _context.next = 33;
            break;

          case 26:
            _context.prev = 26;
            _context.t1 = _context["catch"](20);
            console.error(_context.t1);
            message = _context.t1.message || ''; //
            // json error
            //
            // should be instance of SyntaxError

            if (!(message.match('Unexpected end of JSON input') || message.match(/Unexpected token .* in JSON at position/))) {
              _context.next = 32;
              break;
            }

            return _context.abrupt("return", {
              response: response,
              status: 'failure',
              errorType: 'invalid-json'
            });

          case 32:
            return _context.abrupt("return", {
              status: 'failure',
              errorType: 'unknown',
              response: response
            });

          case 33:
            if (response.ok) {
              _context.next = 35;
              break;
            }

            return _context.abrupt("return", {
              response: response,
              data: data,
              status: 'error',
              errorType: 'http-error',
              httpError: '__other__'
            });

          case 35:
            return _context.abrupt("return", {
              response: response,
              data: data,
              status: 'ok'
            });

          case 36:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10], [20, 26]]);
  }));
  return _doJSONFetch.apply(this, arguments);
}

function getJSON(_x2, _x3) {
  return _getJSON.apply(this, arguments);
}

function _getJSON() {
  _getJSON = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee2(url, env) {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", doJSONFetch({
              url: url,
              env: env,
              method: 'GET'
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getJSON.apply(this, arguments);
}

function fetchJSON(_x4) {
  return _fetchJSON.apply(this, arguments);
}

function _fetchJSON() {
  _fetchJSON = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee3(opts) {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", doJSONFetch(opts));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchJSON.apply(this, arguments);
}